import {
	Box,
	Grid,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	InputAdornment,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import React from "react";
import { useEffect } from "react";
import { sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { resetAllStates, setPGState } from "../productGroupSetupSlice";

export default function CreatePG() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { countries, country, createPGName, createFromDate, createToDate, selectedSKUs } =
		pgState;
	const dispatch = useDispatch();

	const loginState = useSelector((store) => store.login);
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState  
	
	useEffect(() => {
		if(globalSelectedCountryID !== null){
      dispatch(setPGState("countryID", globalSelectedCountryID));
      dispatch(setPGState("pgGlobalCountryID", globalSelectedCountryID));   
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null && globalSelectedCountryName !== ""){
      dispatch(setPGState("country", globalSelectedCountryName));    
		}
	},[globalSelectedCountryName])  	

   const minDate = dayjs().add(1, 'day');

	function showMessage(message, severity) {
		dispatch(setPGState("createMessageOpen", true));
		dispatch(setPGState("createMessage", message));
		dispatch(setPGState("createMessageSeverity", severity));
	}

	function updateCountry(event) {
      dispatch(resetAllStates({ edit: false }));
		const name = event.target.value;
		const id = countries.find(
			(country) => country.countryName === name
		).countryID;
		dispatch(setPGState("country", name));
		dispatch(setPGState("countryID", id));
	}

	function updatePGName(event) {
		const pattern = /^[a-zA-Z0-9 ]*$/;
		if (event.target.value == " ") {
		  event.target.value = event.target.value.replace(" ", "");
		}
		else if (event.target.value.startsWith(" ")) {
		  event.target.value = event.target.value.trimStart();
		}
		if (!pattern.test(event.target.value)) {
		  event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");	
		}
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		const name = event.target.value;
		dispatch(setPGState("createPGName", name));
	}

	function updateFromDate(newDate) {
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
         dispatch(setPGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
		if (newDate >= createToDate) {
			showMessage("From Date cannot be greater than To Date", "info");
         dispatch(setPGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
      console.log("CreatePG_UpdateFromDate", newDate)
		//dispatch(setPGState("createFromDate", newDate));
      if(selectedSKUs.length > 0) {
         setSelectedSKUFromDates(newDate);
      }
	  dispatch(setPGState("createFromDate", newDate));
	}

	function updateToDate(newDate) {
      if (country.length <= 0) {
			showMessage("Please select a country", "info");
         dispatch(setPGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		if (newDate <= createFromDate) {
			showMessage("To Date cannot be less than From Date", "info");
         dispatch(setPGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		const fromDate=dayjs(createFromDate).startOf("day");
		const nDate = dayjs(newDate).startOf("day");
		if (nDate.diff(fromDate, "day") <7) {
			showMessage("Validity must be at least 7 days", "info");
         	//dispatch(setCGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			 dispatch(setPGState("createToDate",dayjs().year(2099).month(11).date(31).startOf("day")));
			return;
		}
      if(selectedSKUs.length > 0) {
         setSelectedSKUTODates(newDate);
      }
	  dispatch(setPGState("createToDate", newDate));	  
	}

   function setSelectedSKUFromDates(date) {
	console.log("CreatePG_SetSelectedSKUFromDates", createFromDate);
      const selSKUs = selectedSKUs.map((item) => {
		const skustartDate = new Date(item.effectiveStartDate);
		const newDate = new Date(date);
        //  return {
        //     ...item,
        //     effectiveStartDate: skustartDate<newDate?date:item.effectiveStartDate, 
        //  };
		return {
			...item,
			effectiveStartDate: (() => {
			  if (createFromDate === item.effectiveStartDate) {
				return date;
			  }
			 if (skustartDate < newDate) {
				return date;
			  }
			  return item.effectiveStartDate;
			})(),
		  };

      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

   function setSelectedSKUTODates(date) {
      const selSKUs = selectedSKUs.map((item) => {
		const skuEndDate = new Date(item.effectiveEndDate);
		const newDate = new Date(date);
        //  return {
        //     ...item,
        //     effectiveEndDate: skuEndDate > newDate? date: item.effectiveEndDate, 
        //  };
		return {
			...item,
			effectiveEndDate: (() => {
			  if (createToDate === item.effectiveEndDate) {
				return date;
			  }
			 if (skuEndDate > newDate) {
				return date;
			  }
			  return item.effectiveEndDate;
			})(),
		  };

      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

	return (
		<Box>
			<Box
				sx={{
					mt: 3,
				}}
			>
				<Grid container columns={8} spacing={3} rowGap={2}>
					<Grid item sm={2}>
						<FormControl sx={{widows:"100%"}}>
							<InputLabel>Country</InputLabel>
							<Select
								value={country}
								label="Country"
								onChange={updateCountry}
							>
								{countries.map((country, index) => {
									return (
										<MenuItem key={index} value={country.countryName}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={2}>
						<TextField
							label="Product Group Name"
							InputProps={{
								startAdornment: (
									<InputAdornment position="end">
										<EditIcon />
									</InputAdornment>
								),
								autoComplete: "off"
							}}
							variant="standard"
							value={createPGName}
							onChange={updatePGName}
						/>
					</Grid>

					<Grid item sm={2}>
						<Box sx={{ mt: 1 }}>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									minDate={minDate}
									label="From"
									value={createFromDate}
									onChange={(newValue) => updateFromDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>

					<Grid item sm={2}>
						<Box sx={{ mt: 1 }}>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									minDate={minDate}
									label="To"
									value={createToDate}
									onChange={(newValue) => updateToDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}
